'use strict';

var workflowEditCtrl = function ($scope, railApi, $stateParams) {
    $scope.lockedDmPermissionEdit = {
        changed: false,
        saving: false
    };

    $scope.markLockedDmPermissionsChanged = function () {
        $scope.lockedDmPermissionEdit.changed = true;
        $scope.editableUpdateResult = null;
    };

    $scope.saveLockedWorkflowDmPermissions = function (workflow) {
        if (!$scope.lockedDmPermissionEdit.changed || $scope.lockedDmPermissionEdit.saving) {
            return;
        }

        $scope.lockedDmPermissionEdit.saving = true;
        $scope.editableUpdateResult = railApi.put('workflows/' + $stateParams.id, workflow, 'workflow');
        $scope.editableUpdateResult.promise.then(function () {
            $scope.lockedDmPermissionEdit.changed = false;
        }).finally(function () {
            $scope.lockedDmPermissionEdit.saving = false;
        });
    };
};

workflowEditCtrl.$inject = ['$scope', 'railApi', '$stateParams'];

module.exports = workflowEditCtrl;
